import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CssBaseline from "@mui/material/CssBaseline";
import useGetPolicyPage from "../../api-manage/hooks/react-query/useGetPolicyPage";
import MainLayout from "../../components/layout/MainLayout";
import PolicyPage from "../../components/policy-page";
import SEO from "../../components/seo";

const Index = ({ configData }) => {
  const { t } = useTranslation();
  const { data, refetch, isFetching } = useGetPolicyPage();
  
  useEffect(() => {
    refetch();
  }, [refetch]);
  
  return (
    <>
      <CssBaseline />
      <SEO
        title={configData ? `About Us` : "Loading..."}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <MainLayout configData={configData}>
        <PolicyPage
          data={{ ...data, value: data }}
          title={t("About us")}
          isFetching={isFetching}
        />
      </MainLayout>
    </>
  );
};

export default Index;
